import styled from "styled-components";

export const SkeletonCard = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  width: 100%;
  max-width: 270px;
  min-width: 0;
  height: 291px;
  box-sizing: border-box;
`;

export const SkeletonImage = styled.div`
  position: relative;
  width: 100%;
  max-width: 250px;
  height: 220px;
  background: linear-gradient(90deg, #e5e7eb 25%, #e0e0e0 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  border-radius: 6px;
  animation: shimmer 1.5s infinite;
  margin: 0 auto;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const SkeletonFooter = styled.div`
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SkeletonMetrics = styled.div`
  display: flex;
  gap: 16px;
`;

export const SkeletonMetric = styled.div`
  width: 40px;
  height: 30px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
`;
